/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import i18n from 'i18next';
import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { safelyInitI18nForTestsAndStories } from '@opengeoweb/shared';
import pluginsTranslations from '../../../locales/plugins.json';

export const PLUGINS_NAMESPACE = 'plugins';

type SharedI18nInstance = Parameters<
  typeof safelyInitI18nForTestsAndStories
>[0];

export const initPluginsI18n = (): typeof i18n => {
  safelyInitI18nForTestsAndStories(
    i18n as SharedI18nInstance,
    PLUGINS_NAMESPACE,
    [{ ns: PLUGINS_NAMESPACE, translations: pluginsTranslations }],
  );
  return i18n;
};

export const usePluginsTranslation = (): UseTranslationResponse<
  typeof PLUGINS_NAMESPACE,
  typeof i18n
> => useTranslation(PLUGINS_NAMESPACE);

export const translateInTestsAndStories = (
  key: string,
  params: Record<string, string | number> | undefined = undefined,
): string => i18n.t(key, { ns: [PLUGINS_NAMESPACE], ...params });

export { i18n };
